import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

export const LinkDesktop = styled(Button)`
  width: 100%;
  white-space: normal;
  ${media.mediumDown`
    display: none;
  `}
`;

export const LinkMobile = styled(Button)`
  display: block;
  max-width: 25px;
  min-height: 30px;
  padding: 5px 2px;
  ${media.largeUp`
    display: none;
  `}
`;

export const StoreLink = styled.div`
  padding: 5px 0;
  width: 100%;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  ${props =>
    props.disabled &&
    css`
      ${LinkDesktop} {
        color: ${p => p.theme.text.tertiary};
        font-weight: normal;
        text-transform: none;
      }
      ${LinkMobile} {
        svg path {
          fill: ${layout.iconColorLighter};
        }
      }
    `}
  ${media.mediumDown`
    padding: 5px 0 5px 10px;
  `}
`;

export const TransparencyShopInfo = styled.p`
  text-align: left;
  margin: 0;
`;
